module.exports = __webpack_public_path__ + "assets/img/songCharTitle.6683bcd3.png";